export default __webpack_public_path__ + "static/media/card-theme6.f644ed6b.svg";